import { call, put } from "redux-saga/effects";
import {
  addLicense,
  editLicense,
  deleteLicense,
  getLicenses,
} from "../../app/components/Ancillary/LicenseManagement/helper/licenseManagementHelper.js";
import {
  addLicenseSuccessAction,
  editLicenseSuccessAction,
  deleteLicenseSuccessAction,
  getLicensesSuccessAction,
} from "./actions";

export function* addLicenseSaga(payload) {
  try {
    const response = yield call(addLicense, payload.licenseData);
    yield put(addLicenseSuccessAction(response.data));
  } catch (err) {}
}

export function* editLicenseSaga(payload) {
  try {
    const response = yield call(editLicense, payload.licenseData);
    yield put(editLicenseSuccessAction(response.data));
  } catch (err) {}
}

export function* deleteLicenseSaga(payload) {
  try {
    const response = yield call(deleteLicense, payload.licenseData);
    yield put(deleteLicenseSuccessAction(response.data));
  } catch (err) {}
}

export function* getLicensesSaga(payload) {
  try {
    const response = yield call(getLicenses, payload.storeId);
    yield put(getLicensesSuccessAction(response.data));
  } catch (err) {}
}